import { useAbstractDropdownContext } from '../abstract-dropdown/AbstractDropdownContext';
import { AbstractDropdownToggle, AbstractDropdownToggleProps } from '../abstract-dropdown/AbstractDropdownToggle';

export interface MenuToggleProps extends Omit<AbstractDropdownToggleProps, OmittedProps> {}

type OmittedProps = 'aria-controls' | 'aria-expanded' | 'aria-haspopup' | 'consumerName' | 'providerName';

export function MenuToggle(forwardedProps: MenuToggleProps) {
  const dropdown = useAbstractDropdownContext(consumerName, providerName);

  return (
    <AbstractDropdownToggle
      {...forwardedProps}
      aria-controls={dropdown.itemsID}
      aria-expanded={dropdown.isExpanded}
      aria-haspopup="menu"
      consumerName={consumerName}
      providerName={providerName}
    />
  );
}

const consumerName = 'MenuToggle';
const providerName = 'Menu';
